export const VideoClassification = {
  SHORT: 'Short',
  VIDEO: 'Video',
};

export const VideoGenre = {
  NEW_AND_COMING_SOON: 'New & Coming Soon',
  TRENDING_NOW: 'Trending Now',
  NORMAL: 'Normal',
};

export const CSVFileStatus = {
  pending: 'Pending',
  in_progress: 'In Progress',
  completed: 'Completed',
  failed: 'Failed',
};
